import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import helpersNumbers from "../../../helpers/numbers";

const STATE_SORT = {
  ASC: 0,
  DESC: 1,
};

function TableIP({ browsers_ip }) {
  const [stateSortView, setStateSortView] = useState(STATE_SORT.ASC);
  const [browsersIP, setBrowsersIP] = useState({});

  useEffect(() => {
    setBrowsersIP(browsers_ip);
  }, [browsers_ip]);

  const sortTable = (column, state) => {
    let browsersIPArray = convertToArray(browsersIP);

    browsersIPArray = browsersIPArray.sort((a, b) => {
      if (state == STATE_SORT.ASC) {
        return parseFloat(a[column]) - parseFloat(b[column]);
      } else if (state == STATE_SORT.DESC) {
        return parseFloat(b[column]) - parseFloat(a[column]);
      }
    });
    setBrowsersIP(convertToObject(browsersIPArray));
  };

  const convertToObject = (browsersIPArray) => {
    let browsersIPObject = {};
    for (let key in browsersIPArray) {
      const item = browsersIPArray[key];
      browsersIPObject[item.ip] = item.count;
    }
    return browsersIPObject;
  };

  const convertToArray = (browsersIP) => {
    let browsersIPArray = [];

    for (let key in browsersIP) {
      const count = browsersIP[key];
      browsersIPArray.push({
        ip: key,
        count: count,
      });
    }

    return browsersIPArray;
  };

  if (Object.entries(browsersIP).length == 0) {
    return <></>;
  }

  return (
    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pb-3">
      <div className="table-responsive pt-3">
        <table className="table table-hilite tbl-td-white-space mb-0">
          <thead>
            <tr>
              <td>شماره IP</td>
              <td>
                <span>تعداد نمایش</span>
                <span
                  className="pr-2 hover"
                  onClick={(e) => {
                    sortTable("count", stateSortView);
                    setStateSortView((prevState) => !prevState);
                  }}
                >
                  <i
                    className={`fa fa-angle-${
                      stateSortView == STATE_SORT.ASC ? "up" : "down"
                    }`}
                  ></i>
                </span>
              </td>
            </tr>
          </thead>
          <tbody>
            {Object.entries(browsersIP).map(([key, value]) => {
              return (
                <tr>
                  <td>{key}</td>
                  <td>
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.addCommaToSeparateGroupThreeNumber(value)
                    )}{" "}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    browsers_ip: state.reportCampaign.browsers_ip,
  };
};

export default connect(mapStateToProps, {})(TableIP);
